import React, { Component } from 'react'
import Navbar from '../components/newhome/Navbar'
import Footer from '../components/newhome/Footer'
import ReferralProgramComponent from '../components/referrals/ReferralProgram.component'
import LoadingSpinner from './../components/shared/LoadingSpinner.component'
import env from './../environments/environment'
import AdminApi from './../api/admin-api/admin-api'

import './ReferralPage.scss'

async function fetchContent() {
  return (
    await Promise.all([
      AdminApi.getAgencyContentBySlug({
        slug: 'referral-program-information',
        active: 1,
      }),
      AdminApi.getAgencyContentBySlug({
        slug: 'referral-form-page',
        active: 1,
      }),
    ])
  ).map((row) =>
    Array.isArray(row?.data?.data)
      ? row?.data?.data.shift()?.content
      : row?.data?.data?.content
  )
}

class ReferralPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      contentData: { program: null, form: null },
    }
  }

  async componentDidMount() {
    const [program, form] = await fetchContent()
    this.setState({ isLoading: false, contentData: { program, form } })
  }

  render() {
    return (
      <div id="ReferralPage" className="page contact-page-custom-wrapper">
        <Navbar />
        <section
          style={{
            backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fsubsites%2Fbg-referral.jpg?alt=media)`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
          className="section-60 section-sm-top-90 section-sm-bottom-100"
        >
          {this.state.isLoading ? (
            <div
              style={{ marginLeft: '10%', marginRight: '10%' }}
              className="referral-loading-spinner"
            >
              <div
                style={{
                  minHeight: '250px',
                  padding: '20px',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                }}
              >
                <LoadingSpinner size="md" isActive={true} />
              </div>
            </div>
          ) : (
            <ReferralProgramComponent content={this.state.contentData} />
          )}
        </section>
        <Footer />
      </div>
    )
  }
}

export default ReferralPage
